var exports = {
  "Ur": "VoiceMessageRecorder.module__voiceButtonWrapper___eEhCUD",
  "VK": "VoiceMessageRecorder.module__voiceButton___eEhCUD",
  "qu": "VoiceMessageRecorder.module__voiceButtonIcon___eEhCUD",
  "hB": "VoiceMessageRecorder.module__holdTooltip___eEhCUD",
  "Yh": "VoiceMessageRecorder.module__recordingOverlay___eEhCUD",
  "Zo": "VoiceMessageRecorder.module__overlayInner___eEhCUD",
  "kK": "VoiceMessageRecorder.module__recordingControls___eEhCUD",
  "PJ": "VoiceMessageRecorder.module__recordingBar___eEhCUD",
  "lL": "VoiceMessageRecorder.module__recordingDot___eEhCUD",
  "O1": "VoiceMessageRecorder.module__timer___eEhCUD",
  "ou": "VoiceMessageRecorder.module__waveform___eEhCUD",
  "hd": "VoiceMessageRecorder.module__waveformBar___eEhCUD",
  "gb": "VoiceMessageRecorder.module__iconButton___eEhCUD",
  "T5": "VoiceMessageRecorder.module__trashButton___eEhCUD",
  "jo": "VoiceMessageRecorder.module__sendButton___eEhCUD",
  "QO": "VoiceMessageRecorder.module__lockIndicatorWrapper___eEhCUD",
  "zY": "VoiceMessageRecorder.module__lockIndicator___eEhCUD",
  "bd": "VoiceMessageRecorder.module__lockIndicatorLocked___eEhCUD",
  "GR": "VoiceMessageRecorder.module__lockIndicatorIcon___eEhCUD",
  "c8": "VoiceMessageRecorder.module__lockIndicatorCaret___eEhCUD",
};

module.exports = exports;
